// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__up9ET","importantInfo":"styles_importantInfo__1nJ6j"};